/**
 * Community social destinations (restored from pre-Blocks Community page).
 * Optional Vite env overrides: VITE_FACEBOOK_URL, VITE_DISCORD_URL, VITE_REDDIT_URL.
 */
import { SUPPORT_MAILTO } from './legal';

export type SocialLinkId = 'facebook' | 'discord' | 'reddit' | 'email';

export type SocialLink = {
  id: SocialLinkId;
  name: string;
  tagline: string;
  cta: string;
  href: string;
  /** Tailwind classes for icon plate / accent */
  accentClass: string;
  iconClass: string;
};

function url(envKey: string, fallback: string): string {
  const value = (import.meta.env[envKey] as string | undefined)?.trim();
  return value || fallback;
}

export const COMMUNITY_SOCIALS: SocialLink[] = [
  {
    id: 'facebook',
    name: 'Facebook',
    tagline: 'Royal decrees, patch notes, and kingdom news.',
    cta: 'Enter the court',
    href: url('VITE_FACEBOOK_URL', 'https://www.facebook.com/blindkingsonline'),
    accentClass: 'from-[#1877F2]/25 to-transparent border-[#1877F2]/50',
    iconClass: 'text-[#4B9BFF]',
  },
  {
    id: 'discord',
    name: 'Discord',
    tagline: 'The war room — find rivals, trade tactics, stay sharp.',
    cta: 'Join the war room',
    href: url('VITE_DISCORD_URL', 'https://discord.gg/sKGZYBYF3G'),
    accentClass: 'from-[#5865F2]/25 to-transparent border-[#5865F2]/50',
    iconClass: 'text-[#8B93FF]',
  },
  {
    id: 'reddit',
    name: 'Reddit',
    tagline: 'Open the scroll — debates, highlights, and clever plays.',
    cta: 'Read the scrolls',
    href: url('VITE_REDDIT_URL', 'https://www.reddit.com/r/blindkings/'),
    accentClass: 'from-[#FF4500]/20 to-transparent border-[#FF4500]/45',
    iconClass: 'text-[#FF6A33]',
  },
  {
    id: 'email',
    name: 'Email',
    tagline: 'Seal a letter to the Blind Kings court.',
    cta: 'Write the court',
    href: SUPPORT_MAILTO,
    accentClass: 'from-bk-gold/20 to-transparent border-bk-gold-dim/60',
    iconClass: 'text-bk-gold-bright',
  },
];
